export default __webpack_public_path__ + "static/media/ART10.d18220c4.jpg";